import { render, staticRenderFns } from "./LogoutIcon.vue?vue&type=template&id=5003dbb2&scoped=true&"
import script from "./LogoutIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LogoutIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003dbb2",
  null
  
)

export default component.exports